import logger from '../utils/rbmc.logger';
import urlUtils from '../utils/rbmc.url-utils'
import spinner from '../utils/rbmc.spinner';

const addressHandling = {
    addressRequired:       $('#address-required'),
    deliveryAddressWrapper: $('#deliveryAddressWrapper'),
    fetchAddress(data, hide, modified) {
        let request = $.ajax({
            url:     urlUtils.getBaseUrl() + 'checkout/multi/address/fetch',
            method:  'GET',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            data:    {
                'type':     data.selector,
                'id':       data.id,
                'modified': modified
            },
            cache:   false
        });
        spinner.spinnerVisibility(true);
        request.done((response) => {
            // replace form content and init select menues
            let selectorToReplace = '#' + data.selector;
            // we have to strip/remove the main html element(the form itself) from response
            $(selectorToReplace).replaceWith($(response).find(selectorToReplace));
            $(selectorToReplace).find('.form-control--select').selectpicker({
                style:      'btn-select',
                dropupAuto: false
            });

            if (hide) {
                logger.debug('sel hide:' + selectorToReplace);
                $(selectorToReplace).addClass('d-none');
            } else {
                logger.debug('sel show:' + selectorToReplace);
                $(selectorToReplace).removeClass('d-none');
            }
            this.checkVisibilityOfRequiredMessage();
        });

        request.fail(function (x, e) {
            logger.debug('Cannot fetch address from backend');
        });

        request.always(() => {
            spinner.spinnerVisibility(false);
        });
    },
    handleBillingAddressAsDeliveryAddressCheckBox(selected) {
        // show/hide the billing address section depending on the checkbox
        if (selected) {
            this.deliveryAddressWrapper.addClass('d-none');
        } else {
            this.deliveryAddressWrapper.removeClass('d-none');
        }
    },
    checkVisibilityOfRequiredMessage() {
        if ($('.btn-select:visible').length) {
            this.addressRequired.removeClass('d-none');
        } else {
            this.addressRequired.addClass('d-none');
        }
    },

    handleAddressValidationMessage() {
        $('.checkout__radio-box ').find('input').on('change', function () {
            $(".checkout__address-invalid").remove()
        })
    },

    toggleNewAddressButton(target, visible) {
        let $target = $(target).closest('.address-wrapper').find('.js-checkout-address__add--wrapper');
        if (visible) {
            $target.show();
        } else {
            $target.hide();
        }
    },
    setValue(target, value) {
        logger.debug('target: ' + target + ' value: ' + value);
        $(target).val(value);
    },

    bindHandlers() {
        $('.js-checkout-address__add').on('click', (evt) => {
            let data = evt.currentTarget.dataset;
            addressHandling.fetchAddress(data, false, false);
            $('input[name="' + data.radioName + '"]').prop('checked', false);
            $(evt.currentTarget)
                    .closest('.address-wrapper')
                    .find('.checkout__radio-box--active')
                    .removeClass('checkout__radio-box--active');
            this.toggleNewAddressButton(evt.currentTarget, false);
            addressHandling.setValue(data.newSelector, true);
            addressHandling.setValue(data.modifiedSelector, false);
        });

        $('.js-checkout-address__edit').on('click', (evt) => {
            evt.preventDefault();
            let data = evt.currentTarget.dataset;
            addressHandling.fetchAddress(data, false, true);
            addressHandling.setValue(data.newSelector, false);
            addressHandling.setValue(data.modifiedSelector, true);
            $(evt.currentTarget)
                    .closest('.checkout__radio-box')
                    .find('.custom-control-radio-input')
                    .prop('checked', 'checked')
                    .end()
                    .addClass('checkout__radio-box--active')
                    .siblings()
                    .removeClass('checkout__radio-box--active');
            this.toggleNewAddressButton(evt.currentTarget, false);
        });

        $('#delivery-address-as-billing-address').on('click', (evt) => {
            addressHandling.handleBillingAddressAsDeliveryAddressCheckBox(evt.currentTarget.checked);
            this.checkVisibilityOfRequiredMessage();
            let value = 'off';
            if (evt.currentTarget.checked) {
                value = 'on';
                addressHandling.setValue('#newAddress', false);
                addressHandling.setValue('#modified', false);
            }
            $(evt.currentTarget).next().val(value);
        });

        $('input[type=radio]').on('change', (evt) => {
            let $self = $(evt.currentTarget);
            // handle the visual state of the white container
            $self.closest('.checkout__radio-box').addClass('checkout__radio-box--active').siblings().removeClass('checkout__radio-box--active');
            // fetch data from edit button after radio buttons
            let data = $self.parent().next().data();
            // here we have to hide the address after fetching the data
            addressHandling.fetchAddress(data, true, false);
            addressHandling.setValue(data.newSelector, false);
            addressHandling.setValue(data.modifiedSelector, false);
            this.toggleNewAddressButton(evt.currentTarget, true);
        });

    }
};

$(() => {
    const $userFormInCheckout =$('#userDetailsForm');
    if ($userFormInCheckout.length) {
        $userFormInCheckout.on('submit', () => {
            if('checkout' in RedBull.tracking) {
                dataLayer.push(RedBull.tracking.checkout.UA);
                if(RedBull.tracking.checkout.GA4 !== undefined) {
                    //we don't track all the checkout steps with the new GA4
                    dataLayer.push(RedBull.tracking.checkout.GA4);
                }
            }
            spinner.spinnerVisibility(true);
        });
    }

    if ($('#checkout-address-page').length) {
        addressHandling.bindHandlers();
        addressHandling.checkVisibilityOfRequiredMessage();
        addressHandling.handleAddressValidationMessage();
    }
});
